// extracted by mini-css-extract-plugin
module.exports = {"container":"analytics-feed_container__Supen","pagination":"analytics-feed_pagination__aXHWU","author":"analytics-feed_author__2IL28","avatar":"analytics-feed_avatar__Qf2uv"};